module.exports = __webpack_public_path__ + "img/722.41b33f42.png";